import Typography from '@/common/Typography'
import { format } from 'date-fns'
// import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { FC } from 'react'
import { useAppSelector } from '@/store/hooks'
import { BackendToUI } from '@/pages/conversion'
import { capitalize } from '@/helpers/strings'

export const NotificationCard: FC<{
  tag: string
  title: string
  message: string
  timestamp: string
  onClose: any
  unread: boolean
  target_type?: {
    data?: {
      id: number
      recruiter_id?: number
    }
    model: string
  }
}> = (props) => {
  const { user_type } = useAppSelector((state) => state.auth)
  const navigate = useNavigate()
  const { tag, title, message, timestamp, unread, onClose, target_type } = props

  const getRoute = () => {
    let route = `/${
      BackendToUI[user_type! as 'recruiter']
    }/app/${tag?.toLowerCase()}?${target_type?.model?.toLowerCase()}=${
      target_type?.data?.id
    }`
    let replace = false
    if (message.includes('profile is incomplete')) {
      route = '/alumni/app/profile'
      replace = true
    } else if (tag?.toLowerCase().includes('recruitment')) {
      if (user_type === 'recruiter') {
        route = `/${
          BackendToUI[user_type! as 'recruiter']
        }/app/recruitment/job-posting?job=${target_type?.data?.id}`
      } else if (user_type === 'admin') {
        route = `/${
          BackendToUI[user_type! as 'recruiter']
        }/app/recruiter/profile?id=${target_type?.data?.recruiter_id}`
      } else {
        let subRoute = ''
        let archived = false
        if (
          ['application update', 'accepted'].includes(
            title?.toLowerCase().replace('.', '')
          )
        ) {
          subRoute = 'ongoing-application'
        } else if (['rejected', 'hired'].includes(title?.toLowerCase())) {
          subRoute = 'archived-application'
          archived = true
        }
        route = `/${
          BackendToUI[user_type! as 'recruiter']
        }/app/recruitment/${subRoute}?application=${target_type?.data?.id}${
          archived ? '&archived=true' : ''
        }`
      }
    } else if (tag?.toLowerCase().includes('engagement')) {
      route = `/${BackendToUI[user_type! as 'recruiter']}/app/engagement?chat=${
        target_type?.data?.id
      }`
    } else if (tag?.toLowerCase().includes('account')) {
      route = `/${
        BackendToUI[user_type! as 'recruiter']
      }/app/recruiter/profile?id=${target_type?.data?.id}`
    } else if (target_type?.model?.toLowerCase().includes('alumnicourse')) {
      route = `/${BackendToUI[user_type! as 'recruiter']}/app/course?id=${
        target_type?.data?.id
      }`
    } else if (target_type?.model?.toLowerCase().includes('survey')) {
      route = `/${
        BackendToUI[user_type! as 'recruiter']
      }/app/survey/results?view=responses`
    }

    return [route, replace, target_type?.data] as const
  }
  const handleNavigate = (e: any) => {
    // e.preventDefault()
    const [route, replace, state] = getRoute()
    navigate(route, { replace, state })

    onClose()
  }

  return (
    <article className='px-4 w-full '>
      <div className='flex flex-col w-full gap-3 items-start py-4 border-b border-[#D9D9D9]'>
        <div className='flex items-center gap-1'>
          {unread ? (
            <span className='w-1 h-1 rounded-full bg-[#F04438]'></span>
          ) : (
            <span className='w-1 h-1 rounded-full bg-[#8DA0A5]'></span>
          )}
          <Typography className='xs font-normal text-[#8DA0A5]'>
            {tag}
          </Typography>
        </div>
        <div className='flex w-full gap-3 items-start'>
          <div className='flex flex-col items-start gap-2 flex-1'>
            <header className='flex w-full justify-between'>
              <div className='flex  items-center gap-1'>
                {/* {unread && (
                  <span className='w-1 h-1 rounded-full bg-[#F04438]'></span>
                )} */}

                <Typography
                  as='h6'
                  className='font-semibold xs normal-case text-jaa-shades-black'
                >
                  {capitalize(title)}
                </Typography>
              </div>
              <div className='w-auto'>
                <Typography className='font-normal xs text-[#5a6d72] whitespace-nowrap'>
                  {Date.parse(timestamp)
                    ? format(new Date(timestamp), 'dd MMM yyyy')
                    : timestamp || ''}
                </Typography>
              </div>
            </header>

            <Typography
              as='a'
              href={getRoute()[0]}
              onClick={handleNavigate}
              className='sm font-normal text-jaa-shades-black hover:underline cursor-pointer'
            >
              {message}
            </Typography>
            {/* {message.includes('profile is incomplete') ? (
              <span
                onClick={handleNavigate}
                className='text-sm text-jaa-shades-gray-4 underline cursor-pointer'
              >
                Go to Profile
              </span>
            ) : null} */}
          </div>
        </div>
      </div>
    </article>
  )
}
